import React from 'react';

interface SearchChipsProps {
  filters: any;
  onRemoveFilter: (filterKey: string, value?: any) => void;
}

const SearchChips: React.FC<SearchChipsProps> = ({ filters, onRemoveFilter }) => {
  const getFilterChips = () => {
    const chips = [];

    // キーワード
    if (filters.keyword) {
      chips.push({
        key: 'keyword',
        label: `キーワード: ${filters.keyword}`,
        value: filters.keyword
      });
    }

    // スキル
    if (filters.skill_ids?.length > 0) {
      filters.skill_ids.forEach((skillId: number) => {
        chips.push({
          key: 'skill_ids',
          label: `スキル: ${skillId}`, // 実際の実装ではスキル名を取得
          value: skillId
        });
      });
    }

    // 職種
    if (filters.occupation_ids?.length > 0) {
      filters.occupation_ids.forEach((occupationId: number) => {
        chips.push({
          key: 'occupation_ids',
          label: `職種: ${occupationId}`, // 実際の実装では職種名を取得
          value: occupationId
        });
      });
    }

    // 業界
    if (filters.industry_ids?.length > 0) {
      filters.industry_ids.forEach((industryId: number) => {
        chips.push({
          key: 'industry_ids',
          label: `業界: ${industryId}`, // 実際の実装では業界名を取得
          value: industryId
        });
      });
    }

    // 特徴
    if (filters.characteristic_ids?.length > 0) {
      filters.characteristic_ids.forEach((characteristicId: number) => {
        chips.push({
          key: 'characteristic_ids',
          label: `特徴: ${characteristicId}`, // 実際の実装では特徴名を取得
          value: characteristicId
        });
      });
    }

    // 勤務スタイル
    if (filters.workstyle_types?.length > 0) {
      filters.workstyle_types.forEach((workstyle: string) => {
        chips.push({
          key: 'workstyle_types',
          label: `勤務スタイル: ${workstyle}`,
          value: workstyle
        });
      });
    }

    // 勤務可能日数
    if (filters.availability_types?.length > 0) {
      filters.availability_types.forEach((availability: string) => {
        chips.push({
          key: 'availability_types',
          label: `勤務可能日数: ${availability}`,
          value: availability
        });
      });
    }

    // 価格帯
    if (filters.price_range) {
      chips.push({
        key: 'price_range',
        label: `価格帯: ${filters.price_range}`,
        value: filters.price_range
      });
    }

    return chips;
  };

  const chips = getFilterChips();

  if (chips.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded shadow-sm p-3 mb-4 border-start border-primary border-4">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <h6 className="mb-2 text-primary fw-bold">
            <i className="bi bi-funnel me-1"></i>現在の検索条件
          </h6>
          <div className="d-flex flex-wrap gap-2">
            {chips.map((chip, index) => (
              <span key={index} className="badge bg-primary d-flex align-items-center">
                {chip.label}
                <button
                  type="button"
                  className="btn-close btn-close-white ms-2"
                  style={{ fontSize: '0.7em' }}
                  onClick={() => onRemoveFilter(chip.key, chip.value)}
                  aria-label="削除"
                ></button>
              </span>
            ))}
          </div>
        </div>
        <button 
          className="btn btn-outline-secondary btn-sm"
          onClick={() => {
            // 全条件をクリア
            window.location.href = '/job_listings/search';
          }}
        >
          <i className="bi bi-x-circle me-1"></i>条件をクリア
        </button>
      </div>
    </div>
  );
};

export default SearchChips;
